var mainSlider;
var expandSlider;

$(document).ready(function() {
    showAddToCart();

    init_mainSlider();
    init_expandSlider();

    $('#your-product-bike .btn-expand').on('click', function() {
        $('html, body').css('overflow-y', 'hidden');
        $('#gallery-expand').show();
    });
    
    $('#gallery-expand .btn-expand-close').on('click', function() {
        $('html, body').css('overflow-y', 'visible');
        $('#gallery-expand').hide();
    });

    let lastVisibleInfo = null;
    $('.product-info .info').each(function() {
        if ($(this).css('display') === 'block') {
            lastVisibleInfo = $(this);
        }
    });

    if (lastVisibleInfo) {
        lastVisibleInfo.css({
            'border-bottom': 'none',
            'padding-bottom': '0'
        });
    }
});

$(window).scroll(function() {
    showAddToCart();
});

function attachMutation_galleryEpand() {
    let $gallery_expand = $('#gallery-expand .owl-stage');

    function detectActiveChild() {
        let $children = $gallery_expand.find('.owl-item');
        $children.each(function(index) {
            if ($(this).hasClass('active')) {
                mainSlider.trigger('to.owl.carousel', index);
            }
        });
    }

    let observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                detectActiveChild();
            }
        });
    });

    let config = {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
    };
    
    observer.observe($gallery_expand[0], config);
}

function init_mainSlider() {
    mainSlider = $("#your-product-bike .owl-carousel").owlCarousel({
        items: 1,
        slideBy: 1,
        dots: true,
        nav: true,
        margin: 50,
        smartSpeed: 500,
        navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
        responsive: {
            0 : {
                nav: false
            },
            768 : {
                nav: true
            }
        }
    }).on('changed.owl.carousel', function(event) {
        expandSlider.trigger('to.owl.carousel', event.item.index);
    });
}

function init_expandSlider() {
    expandSlider = $("#gallery-expand .owl-carousel").owlCarousel({
        items: 1,
        slideBy: 1,
        dots: true,
        nav: true,
        margin: 50,
        smartSpeed: 500,
        navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
        responsive: {
            0 : {
                nav: false
            },
            768 : {
                nav: true
            }
        }
    });

    attachMutation_galleryEpand();
}

var $hideAddToCart_1 = $('#async-newsletter');
var $hideAddToCart_2 = $('.async-footer');
function showAddToCart() {
    let hidePercentage;
    let popup = $('#async-floating-add-to-cart');

    $('#async-floating-add-to-cart').css('bottom', `-${popup.innerHeight()}px`);

    if($hideAddToCart_1.is(':visible')) {
        hidePercentage = calculateSectionPercentage($hideAddToCart_1);
    }
    else if ($hideAddToCart_2.is(':visible')) {
        hidePercentage = calculateSectionPercentage($hideAddToCart_2);
    }

    if (($(window).scrollTop() >= (1 * $(window).height())) && hidePercentage == 100) {
        $('#async-floating-add-to-cart').css({
            'bottom': '0',
            'opacity': '1'
        });
    }
    else {
        $('#async-floating-add-to-cart').css({
            'bottom': `-${popup.innerHeight()}px`,
            'opacity': '0'
        });
    }
}

$('#async-floating-add-to-cart .btn-atc-floating').on('click', function() {
    $('#your-product-bike .atc-form').trigger('submit');
});

$('#your-product-bike .btn-pswp').on('click', function() {
    let slide = $('#your-product-bike .owl-carousel.variant--slider .owl-stage .owl-item.active').index();
    $(`#your-product-bike .pswp-gallery img:eq(${slide})`).trigger('click');
});